<template lang='pug'>
md-theme(md-name='white-brown')
  md-toolbar.toolbar
    router-link.md-title(:to="{name: 'Marketplace'}")
      img.rhebus-logo(src='../assets/img/RhebusTV_logo.jpg')
    span(style='flex: 1')

    .compact-button
      router-link(:to="{name: 'Marketplace'}")
        md-button
          md-icon.on-left(md-iconset="fa fa-film")
          span.hiddenText
            | Find Videos
      router-link(:to="{name: 'CreateDistribution'}")
        md-button
          md-icon.on-left(md-iconset="fa fa-share-square")
          span.hiddenText
            | Distribute Content

    md-menu.compact-button(md-align-trigger, md-direction='bottom left', ref='reportingMenu', md-size='4')
      md-button(md-menu-trigger='')
        md-icon.on-left(md-iconset="fa fa-chart-bar")
        span.hiddenText
          | Reporting
      md-menu-content(v-on:click.native='reportingMenuClicked')
        md-menu-item
          router-link(:to="{name: 'Reports'}")
            md-icon.on-left(md-iconset="fa fa-chart-line")
            span
              | Views
        md-menu-item
          router-link(:to="{name: 'Domains'}")
            md-icon.on-left(md-iconset="fa fa-building")
            span
              | Domains
        md-menu-item
          router-link(:to="{name: 'Licensing'}")
            md-icon.on-left(md-iconset="fa fa-file-contract")
            span
              | Licensing
        md-menu-item(v-if='isSuperAdmin()')
          router-link(:to="{name: 'FinancialSummary'}")
            md-icon(md-iconset="fa fa-file-invoice")
            span
              | Platform Billing

    md-menu.compact-button(md-align-trigger, md-direction='bottom left', ref='mainMenu', md-size='4')
      md-button.md-icon-button(md-menu-trigger='', id='hamburger')
        md-icon(md-iconset="fa fa-bars")
      md-menu-content(v-on:click.native='mainMenuClicked')
        md-menu-item
          router-link(:to="{name: 'DistributionList'}")
            md-icon(md-iconset="fa fa-share-square")
            span Distributions
        md-menu-item
          router-link(:to="{name: 'DomainList'}")
            md-icon(md-iconset="fa fa-building")
            span Domains
        md-menu-item
          router-link(:to="{name: 'Videos'}")
            md-icon(md-iconset="fa fa-file-video")
            span Videos
        md-menu-item
          router-link(:to="{name: 'VideoSources'}")
            md-icon(md-iconset="fa fa-rss")
            span Video Sources
        md-menu-item
          router-link(:to="{name: 'Playlists'}")
            md-icon(md-iconset="fa fa-stream")
            span Playlists
        md-menu-item
          router-link(:to="{name: 'Series'}")
            md-icon(md-iconset="fa fa-film")
            span Series
        md-menu-item
          router-link(:to="{name: 'LicenseList'}")
            md-icon(md-iconset="fa fa-user-lock")
            span Licenses
        md-menu-item
          router-link(:to="{name: 'UserLogsList'}")
            md-icon(md-iconset="fa fa-address-card")
            span User Activity

    md-menu.user-menu(md-align-trigger, md-direction='bottom left', md-size='4', ref='userMenu')
      md-button(md-menu-trigger='')
        md-avatar.user-avatar
          img(:src='siteuser.picture', :alt='siteuser.nickname')
        span.md-hide-xsmall
          span.username.italic {{ siteuser.user_metadata.name }}
          sub.hiddenText.italic
            small {{ isAdmin() ? ' ADMIN' : (isAccountAdmin() ? ' ACCOUNT ADMIN' : '') }}
      md-menu-content(v-on:click.native='userMenuClicked')
        md-menu-item
          router-link(:to="{name: 'EditUser', params: {id: encodeURIComponent(siteuser.user_id) }}", :exact="true")
            md-icon(md-iconset="fa fa-user-circle")
            span My Profile
        md-menu-item(v-if='isAdmin()')
          router-link(:to="{name: 'AccountList'}")
            md-icon(md-iconset="fa fa-users-cog")
            span Accounts
        md-menu-item(v-if='isAdmin()')
          router-link(:to="{name: 'Impersonate'}")
            md-icon(md-iconset="fa fa-user-ninja")
            span Impersonate
        md-menu-item(v-if='isAccountAdmin()')
          router-link(:to="{name: 'EditAccount', params: {id: this.siteuser.user_metadata.account_id }}")
            md-icon(md-iconset="fa fa-users-cog")
            span Account
        md-menu-item(v-if='isAdmin() || isAccountAdmin()')
          router-link(:to="{name: 'UserList'}", :exact="true")
            md-icon(md-iconset="fa fa-users")
            span Users
        md-menu-item
          router-link(:to="{name: 'PartnerIntegration'}")
            md-icon(md-iconset="fa fa-puzzle-piece")
            span Partner Integrations
        md-menu-item(@click='logout()')
          md-icon(md-iconset="fa fa-sign-out-alt")
          span Sign Out
        p.version-number {{ versionNumber }}
</template>

<script type="text/javascript">
  import { mapState, mapGetters } from 'vuex';
  import Cookies from 'js-cookie';
  import { version } from '../../package.json';

  export default {
    computed: {
      ...mapGetters('user', ['getFeatureValue']),
      ...mapState({
        siteuser: state => state.user.siteuser
      }),
    },
    props: {
      hideMenu: {
        type: Boolean,
        default() { return false; }
      },
      title: {
        type: String,
        default() { return ''; }
      },
      options: {
        type: Array,
        default() { return []; }
      }
    },
    data() {
      return {
        progress: 0,
        progressInterval: null,
        done: false,
        transition: true,
        versionNumber: version
      };
    },
    methods: {
      mainMenuClicked() {
        this.$refs.mainMenu.close();
      },
      userMenuClicked() {
        this.$refs.userMenu.close();
      },
      reportingMenuClicked() {
        this.$refs.reportingMenu.close();
      },
      toggleSidenav() {
        this.$emit('TOGGLE_SIDEBAR');
      },
      isAdmin() {
        // Check user has 'authorization' and Check user has 'roles'
        if (this.siteuser.authorization && this.siteuser.authorization.roles) {
          return this.siteuser.authorization.roles.includes('Admin');
        }
        return false;
      },
      isSuperAdmin() {
        if (this.siteuser.authorization && this.siteuser.authorization.roles) {
          return this.siteuser.authorization.roles.includes('SuperAdmin');
        }
        return false;
      },
      isAccountAdmin() {
        // Check user has 'authorization' and Check user has 'roles'
        if (this.siteuser.authorization && this.siteuser.authorization.roles) {
          return this.siteuser.authorization.roles.includes('AccountAdmin');
        }
        return false;
      },
      logout() {
        Cookies.remove('dateTimeCloseExpiredAlert');
        this.$router.push('/logout');
      }
    },
    mounted() {
      var roles = this.siteuser && this.siteuser.authorization && this.siteuser.authorization.roles;
      console.log('[Toolbar] User roles:', roles);
    }
  };
</script>

<style lang="scss" scoped>
  .md-toolbar.toolbar {
    height: 78px;
    box-shadow: 0 0 20px rgba(0, 0, 0, .15);

    .md-title {
      font-weight: 300;
    }
  }
  .italic{
    font-style: italic;
  }
  @media (max-width: 1200px) {
    .username{
    display: none;
  }
  }

  @media (max-width: 1000px){
    .hiddenText{
    display: none;
  }
  }

  .on-left {
    margin-top: -2px;
    margin-right: 3px;
  }
  .rhebus-logo {
    max-width: 160px;
    margin-left: 15px;
  }
  .user-menu {
    margin-left: 5px;
    .user-avatar {
      margin-right: 5px;
    }
  }
  .compact-button {
    @media (max-width: 768px) {
      button {
        min-width: 0;
        margin: 6px 0;
        padding: 0 10px;
      }
    }
  }

  .md-theme-white-brown.md-list .md-list-item .router-link-active.md-list-item-container {
    background: #4ea9dd;
  }

  .version-number {
    display: flex;
    justify-content: end;
    margin: 0;
    padding-right: 10px;
    color: #4ea9dd;
  }
</style>



// WEBPACK FOOTER //
// src/shared-components/Toolbar.vue